export class CarouselTrack extends HTMLElement {
  connectedCallback() {
    this.classList.add('glide__track');
    this.setAttribute('data-glide-el', 'track');
  }

  disconnectedCallback() {
    this.classList.add('glide__track');
    this.removeAttribute('data-glide-el', 'track');
  }
}